import React from 'react'
// Library
import { Col, Container, Row } from 'react-bootstrap'
import Team1 from '../assets/images/team-1.jpeg';
import Team2 from '../assets/images/team-2.png';

const teamData=[
    {
        id:1,
        designation:"Project manager",
        totalStaff:"3",
    },
     {
        id:2,
        designation:"Quality engineer",
        totalStaff:"4",
    },
     {
        id:3,
        designation:"Site engineer",
        totalStaff:"8",
    },
     {
        id:4,
        designation:"Site supervisor",
        totalStaff:"12",
    },
     {
        id:5,
        designation:"Planning engineer",
        totalStaff:"2",
    },
     {
        id:6,
        designation:"Safety engineer",
        totalStaff:"3",
    },
     {
        id:7,
        designation:"HR Officer",
        totalStaff:"1",
    },
     {
        id:8,
        designation:"Electrician",
        totalStaff:"3",
    }, {
        id:9,
        designation:"plant opretor",
        totalStaff:"4",
    }
]

const OurTeam = () => {

    return (
        <Container>
            <div className="text-center">
                <h2 className='center'>Our <span>Team</span></h2><br />
                <p>What makes us the best choice</p>
            </div>
            <Row className='justify-content-center'>
                <Col md={3}>
                    <div className="project-single team  mt-5">
                        <img src={Team1} alt="Project" className="img-fluid" />
                        <h4>Mr. Swarupsinh Narsinh Sodha<br /><br />Managing Director </h4>
                    </div>
                </Col>
                <Col md={3}>
                    <div className="project-single team mt-5">
                        <img src={Team2} alt="Project" className="img-fluid" />
                        <h4>Mr. Nathusinh Lalji Sodha <br /><br />Managing Director </h4>
                    </div>
                </Col>
                {/*<Col md={3}>
                    <div className="project-single team  mt-5">
                        <img src={Team3} alt="Project" className="img-fluid" />
                        <h4>Mr. Nareshkumar Devji Suthar <br /><br />CEO </h4>
                    </div>
                </Col>
                <Col md={3}>
                    <div className="project-single team  mt-5">
                        <img src={Team4} alt="Project" className="img-fluid" />
                        <h4>Mr. Chandansinh Sonji Sodha <br /><br />Chief Financial Officer </h4>
                    </div>
                </Col>*/}
            </Row>

            {/**Team table */}
            <div className="text-center">
                        </div>
                        <Row className='d-flex justify-content-center pt-5'>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover table-striped spec-table">
                                    <thead className="table-secondary">
                                        <tr>
                                        <th className="text-center">No.</th>
                                            <th className="text-center">Designation</th>
                                            <th className="text-center">Total Staff</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {teamData.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.id}.</td>
                                                <td>{item.designation}</td>
                                                <td>{item.totalStaff}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
            
                        </Row>
        </Container >
    )
}

export default OurTeam
